import { getApiRequest } from 'api';
import { CourseGroup } from 'types/courseGroup';

export const getCourseGroupsByCourse = (courseId: number): Promise<CourseGroup[]> => {
    return getApiRequest(`/course-groups/?course=${courseId}`);
};
